import { ReactNode } from 'react';
import Typography from '@mui/material/Typography';

interface ActionDescriptionProps {
  description?: ReactNode;
}

export default function ActionDescription({
  description,
}: ActionDescriptionProps) {
  if (!description) {
    return null;
  }

  return (
    <Typography sx={{ color: 'text.secondary', fontSize: 12, mt: 1, mb: 2 }}>
      {description}
    </Typography>
  );
}
